module.exports = __webpack_public_path__ + "static/media/ufc-logo-mini-faded.5e822687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ufc-logo-mini-faded.png
// module id = 367
// module chunks = 0